type KeyOfType<T, TProp> = { [P in keyof T]: T[P] extends TProp? P : never } [keyof T];

class SortHelper {
    static sortByProperty<T>(property: KeyOfType<T, number> )  {
        return (a: T, b: T): number => {
            if (a[property] > b[property]) {
                return 1;
            }
            return -1;
        };
    }
}

export {SortHelper}